import React from 'react';
import PropTypes, { InferProps } from 'prop-types';
import styled from '@emotion/styled';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';

const DropdownWrapper = styled.div`
  overflow: visible;
  margin-left: -2px;
`;

const DropdownMenuButton = styled.span`
  margin: 0;
  padding: 0;
  min-width: 24px;
`;

const DropdownMenu = styled(Menu)`
  .MuiPopover-paper {
    margin-top: 4px; 
    border: 1px solid var(--grey-light);
  }
  ul {
    padding-top: 8px;
    padding-bottom: 4px;
  }
  li {
    padding: 4px 12px;
  }
  a {
    display: flex;
    align-items: center;
    justify-content: left;
  }
  span {
    padding-left: 8px;
  }
`;

const dropdownPropertyTypes = {
  top: PropTypes.node.isRequired,
  menuItems: PropTypes.arrayOf(
    PropTypes.node,
  ).isRequired,
};

type DropdownProperties = InferProps<typeof dropdownPropertyTypes>;

const Dropdown = ({
  top,
  menuItems,
}: DropdownProperties) => {
  const [anchorElement, setAnchorElement] = React.useState<
  HTMLElement | undefined
  >();

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorElement(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorElement(undefined);
  };

  return (
    <DropdownWrapper>
      <DropdownMenuButton
        aria-controls="simple-menu"
        aria-haspopup="true"
        onClick={handleClick}
      >
        { top }
      </DropdownMenuButton>
      <DropdownMenu
        id="simple-menu"
        anchorEl={anchorElement}
        elevation={0}
        open={Boolean(anchorElement)}
        onClose={handleClose}
        keepMounted
        disableScrollLock
      >
        {
          menuItems.map((item, index) => (
            // eslint-disable-next-line react/no-array-index-key
            <MenuItem onClick={handleClose} key={index}>
              { item }
            </MenuItem>
          ))
        }
      </DropdownMenu>
    </DropdownWrapper>
  );
};

Dropdown.propTypes = dropdownPropertyTypes;

export default Dropdown;
